export default {
	title: 'Configuración de Modelo de Algoritmo',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote',
		modelConfig: 'Configuración del Modelo',
		configHistory: 'Historial de Configuración',
		addHealthCalculation: 'Agregar Cálculo de Salud',
		start: 'Iniciar',
		stop: 'Detener',
		refreshAlgorithmModel: 'Actualizar Modelo de Algoritmo'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		setSuccess: 'Configuración exitosa',
		configSuccess: 'Configuración exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		noConfigHistory: 'No hay historial de configuración disponible',
		confirmAddHealthCalculation: '¿Está seguro de que desea agregar cálculo de salud?',
		confirmRefreshAlgorithmModel:
			'¿Está seguro de que desea actualizar el modelo de algoritmo? Esta operación regenerará la configuración del modelo.',
		confirmAdd: 'Confirmar Agregar',
		confirmRefresh: 'Confirmar Actualizar',
		addHealthCalculationSuccess: 'Cálculo de salud agregado exitosamente',
		refreshAlgorithmModelSuccess: 'Modelo de algoritmo actualizado exitosamente',
		getConfigHistoryError: 'Error al obtener datos detallados'
	},
	form: {
		deviceName: 'Dispositivo',
		pointNo: 'Número de Punto',
		code: 'Código de Grupo de Modelos',
		name: 'Nombre del Grupo de Modelos',
		mmcodeList: 'Seleccionar Modelo',
                sys: 'Seleccionar valores característicos',
		placeholder: {
			deviceName: 'Por favor ingrese el nombre del dispositivo',
			pointNo: 'Por favor ingrese el número de punto',
			code: 'Por favor ingrese el código de grupo de modelos',
			name: 'Por favor ingrese el nombre del grupo de modelos'
		}
	},
	table: {
		projNo: 'N° de Proyecto',
		deviceName: 'Dispositivo',
		deviceNo: 'N° de Dispositivo',
		sensorName: 'Sensor',
		pointNo: 'Número de Punto',
		name: 'Nombre',
		mtype: 'Tipo de Modelo',
		mmcode: 'Código del Modelo',
                eigenKey: 'Valores característicos',
		isEnable: 'Habilitado'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		modelConfigTitle: 'Configuración del Modelo',
		configHistoryTitle: 'Historial de Configuración'
	},
	gridLayout: 'Diseño de Cuadrícula',
	columns: {
		deviceName: 'Nombre del Dispositivo',
		sensorName: 'Nombre del Sensor',
		modelGroupName: 'Nombre del Grupo de Modelos',
		modelCode: 'Código del Modelo',
		modelName: 'Nombre del Modelo',
		isEnabled: 'Habilitado',
		action: 'Acción'
	},
	config: {
		selectDevice: 'Seleccionar Dispositivo',
		selectSensor: 'Seleccionar Sensor',
		selectAlgorithmGroup: 'Grupo de Modelos de Algoritmo',
		paramType: 'Tipo de Parámetro',
		paramValue: 'Valor de Parámetro',
		paramDesc: 'Descripción de Parámetro',
		configParam: 'Parámetro de Configuración',
		configTime: 'Tiempo de Configuración'
	},
	detailConfig: {
		title: 'Configuración Detallada',
		expandTitle: '{pointNo} - {sensorName} - Configuración Detallada'
	}
}
